import { Clickable } from '@shared/Frontend/components/clickable'
import { Img } from '@shared/Frontend/components/img'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import * as React from 'react'
import { QuoteBlock } from '../../blocks.state'

export const QuoteBlockLayout = (props: QuoteBlock & { id: string }) => {
  const { id, image, primaryUpdater, secondaryUpdater, showUpdaterAsLink } = props

  const { inView, ref } = useInView({ threshold: 0.1 })
  const hasPrimaryUpdater = primaryUpdater && primaryUpdater.title && primaryUpdater.url
  const hasSecondaryUpdater = secondaryUpdater && secondaryUpdater.title && secondaryUpdater.url
  return (
    <section
      id={id}
      ref={ref}
      className={cn(`block block--quote quote--${image ? 'image' : 'text'} ls-block-spacing`, inView && 'inview')}
    >
      <div className="block__inner ls-container">
        <div className="block__layout ls-columns">
          <div className={cn('block__content', image ? 'ls-columns__main' : 'ls-columns__main-text')}>
            {image && (
              <div className="block__visual">
                <Img {...image} loading="lazy" className="block__image" width="330" height="330" />
              </div>
            )}

            <div className="block__text">
              <QuoteLayout {...props} />

              {(hasPrimaryUpdater || hasSecondaryUpdater) && (
                <footer className="block__footer ls-clickables">
                  {hasPrimaryUpdater && (
                    <div className="ls-clickable">
                      <Clickable
                        elementKind="link"
                        styleKind="button"
                        {...primaryUpdater}
                        className="outline-button"
                        onClick={() =>
                          pushDatalayer({
                            category: 'QuoteBlock',
                            action: primaryUpdater.title
                          })
                        }
                      />
                    </div>
                  )}

                  {/* In Van Oord, Quote block currently only has 1 link */}
                  {/* {hasSecondaryUpdater && (
                  <div className="ls-clickable">
                    <Clickable
                      elementKind="link"
                      styleKind="link"
                      {...secondaryUpdater}
                      className="block__clickable block__clickable--secondary"
                      onClick={() =>
                        pushDatalayer({
                          category: 'QuoteBlock',
                          action: secondaryUpdater.title
                        })
                      }
                    />
                  </div>
                )} */}
                </footer>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export const QuoteLayout = (props: {
  text: QuoteBlock['text']
  author?: QuoteBlock['author']
  authorDescription?: QuoteBlock['authorDescription']
}) => {
  const { text, author, authorDescription } = props
  return (
    <>
      <blockquote className="quote">
        <p className="quote__text quote--m" dangerouslySetInnerHTML={{ __html: text }} />
      </blockquote>

      {(author || authorDescription) && (
        <figcaption className="quote__caption text--s">
          {author && <span className="quote__author">{author}</span>}
          {/* NB: Van Oord doesn't use the author description field */}
          {/* {authorDescription && <span className="quote__description">{`, ${authorDescription}`}</span>} */}
        </figcaption>
      )}
    </>
  )
}
